export default {"src":"/_next/static/media/restaurants.e082f46b.svg","height":136,"width":172,"blurWidth":0,"blurHeight":0};